import React from 'react'
import { EventType, SchemaManager } from '../schemamanager/schemaManager'
import { IComponent } from '../schemamanager/types'

export interface IDropdownProps {
  sm: SchemaManager
  comp: IComponent
  items: string[]
  onItemSelected: (item: string) => void
  onEscKey: () => void
}

export const Dropdown = ({sm, comp, items, onItemSelected,onEscKey}: IDropdownProps) => {
  React.useEffect(() => {
    sm.on(EventType.FoucsDropdown, doFocus)
    return () => {
      sm.removeListener(EventType.FoucsDropdown, doFocus)
    }
  }, [sm])

  const doFocus = (compToFocus: IComponent) => {
    if (compToFocus === comp) {
      if (refs.current && refs.current.length > 0) {
        refs.current[0].current?.focus()
      }
    }
  }

  const refs: any = React.useRef([])

  refs.current = []
  items.map(() => refs.current.push(React.createRef()))
  let ind = 0

  const handleKeyDown = (event: any) => {
    event.stopPropagation()
    // arrow down
    if (event.keyCode === 40) {
      if (refs.current && refs.current.length > ind + 1) {
        ind++
        refs.current[ind]?.current?.focus()
      }
    }
    // arrow up
    else if (event.keyCode === 38) {
      if (refs.current && refs.current.length > ind - 1 && ind - 1 >= 0) {
        ind--
        refs.current[ind].current?.focus()
      }
    }
    // esc
    else if (event.keyCode === 27) {
      onEscKey()
    }
  }

  const onSelected = (o: string) => (ev: any) => {
    console.log(o)
    ev.stopPropagation()
    onItemSelected(o)
  }

  const opt = () => {
    return items.map((o, ind) => {
      return (
        <button
          key={o}
          ref={refs.current[ind]}
          onClick={onSelected(o)}
          type='button'
          className='block text-left w-full px-4 py-2 text-sm leading-5 text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-400'
          role='menuitem'
        >
          {o}
        </button>
      )
    })
  }

  if (!items || items.length === 0) return null

  return (
    <div className='absolute left-0 rounded-md shadow-lg z-50'>
      <div className='py-1' role='menu'>
        <div
          className='rounded-md bg-white shadow-xs'
          onKeyDown={handleKeyDown}
        >
          {opt()}
        </div>
      </div>
    </div>
  )
}
